import WhitelistRequestFormStateDefinition from '../WhitelistRequestFormStateDefinition';

export default function whitelistRequestFormReducer(
  state = WhitelistRequestFormStateDefinition.getInitialState()
) {
  return state;
}
